// extracted by mini-css-extract-plugin
module.exports = {"card":"pokemonCard_card__3BtAS"};